import MyCanvasDraw from './canvasDraw.vue'
// 这里是重点
const CanvasDraw = {
    install: function(Vue){
        Vue.component('CanvasDraw',MyCanvasDraw)
    }
};

// 导出组件
export default CanvasDraw


// WEBPACK FOOTER //
// ./src/module/canvasDraw/index.js